import React, { Component } from 'react';
import { ButtonToolbar, Button, Form, FormGroup, ControlLabel, Checkbox, FormControl} from 'react-bootstrap';
import { SetOfDayTypesCommand } from '../../commands/SetOfDayTypesCommand';
import { HandleMessage } from '../../../HandleMessage';
import { LoadingSpinner } from '../../../LoadingSpinner';
import Select from "react-select";

export class DayVerticalTimesheetDataIdentifier extends Component {
    constructor(props) {
        super(props);

        let stopsListConfiguration = {
            show: false,
            id: props.selectedData || null,
            showHourZebraStripes: false,
            showMinutesZebraStripes: false,
            numberColumns: undefined,
            startingHour: undefined,
        };

        try {
            const parsedConfig = JSON.parse(props.configuration);
            stopsListConfiguration = Object.assign(stopsListConfiguration, parsedConfig);
        } catch (error) {
        }

        this.state = {
            selectedData: props.selectedData,
            table: {
                data: [],
                loading: true,
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
            },
            form: {
                show: stopsListConfiguration.show,
                id: stopsListConfiguration.id,
                showHourZebraStripes: stopsListConfiguration.showHourZebraStripes,
                showMinutesZebraStripes: stopsListConfiguration.showMinutesZebraStripes,
                numberColumns: stopsListConfiguration.numberColumns,
                startingHour: stopsListConfiguration.startingHour,
            },
            actions: {
                isLoading: true,
            }
        };

        this.getAllData(false);
    }

    getAllData(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoading = true;

            this.setState({
                table: {
                    data: [],
                    page: 1,
                    elementsPerPage: 10
                },
                actions: actions
            });
        }

        const setOfDayTypesCommand = new SetOfDayTypesCommand();
        setOfDayTypesCommand.list(
            (a) => this.successCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    // ---------------------------

    successCallback(result) {
        const { table, actions, form } = this.state;
        const config = result && result.configuration ? JSON.parse(result.configuration) : {};

        actions.isLoading = false;
        table.data = result;

        form.id = result.dataIdentifyer || form.id;
        form.showHourZebraStripes = config.showHourZebraStripes !== undefined ? config.showHourZebraStripes : form.showHourZebraStripes;
        form.showMinutesZebraStripes = config.showMinutesZebraStripes !== undefined ? config.showMinutesZebraStripes : form.showMinutesZebraStripes;
        form.numberColumns = config.numberColumns !== undefined ? Number(config.numberColumns) : form.numberColumns;
        form.startingHour = config.startingHour !== undefined ? Number(config.startingHour) : form.startingHour;

        this.setState({
            table,
            actions,
            form
        });
    }

    errorCallback(message) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.data = [];

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onSelectData(selectedData) {
        const form = this.state;
        form.id = selectedData.value;

        this.setState({
            form,
            selectedData
        });
    }

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    onChangeValue(selectedData, target) {
        const { form } = this.state;

        if (selectedData) {
            form[target] = selectedData.value; 
        } else {
            form[target] = null;
        }

        this.setState({
            form: form
        });
    }

    onFinishSelectData() {
        const { form } = this.state;
        const data = form.id;

        const configuration = {
            showHourZebraStripes: form.showHourZebraStripes,
            showMinutesZebraStripes: form.showMinutesZebraStripes,
            numberColumns: form.numberColumns,
            startingHour: form.startingHour,
        };

        // Trigger save actions
        this.props.onSelectData(data);
        this.props.onConfigureData(JSON.stringify(configuration), true);

        this.setState({
            selectedData: null,
            form: {
                show: false,
                id: null,
                showHourZebraStripes: false,
                showMinutesZebraStripes: false,
                numberColumns: undefined,
                startingHour: undefined,
            },
            styles: {},
        });
    }

    onCancelSelectData() {
        this.setState({
            form: {
                show: false,
                id: 0,
                showHourZebraStripes: false,
                showMinutesZebraStripes: false,
                numberColumns: undefined,
                startingHour: undefined,
            }
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // -----------------------

    renderSetsOfDayTypes(isLoading, partialData) {
        const options = partialData.map((obj) => ({
            value: obj.id,
            label: obj.name,
        }));

        const { form } = this.state;

        const selectedOption = options.find(option => option.value === Number(form.id));

        return (
            <div>
                <FormGroup controlId="formSetOfDayTypeText">
                    <ControlLabel>Conjunto Tipo de Dia</ControlLabel>
                    {isLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <Select
                            options={options}
                            placeholder="Conjunto tipo de dia"
                            value={selectedOption}
                            onChange={(e) => this.onChangeValue(e, 'id')}
                            isClearable
                            isSearchable
                        />
                    )}
                </FormGroup>
            </div>
        );
    }

    handleFormFieldChange(field) {
        return (e) => {
            const value = e.target.type === "number" ? Number(e.target.value) : e.target.value;
            const updatedForm = this.state.form;
            updatedForm[field] = value;
            this.setState({ form: updatedForm });
        };
    }

    renderTextInput(label, placeholder, value, controlId, onChange) {
        return (
            <FormGroup controlId={controlId}>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
            </FormGroup>
        );
    }

    renderNumberInput(label, placeholder, value, controlId, min, max, onChange) {
        return (
            <FormGroup controlId={controlId}>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    type="number"
                    min={min}
                    max={max}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
            </FormGroup>
        );
    }

    renderCheckbox(label, value, onChange, disabled = false, style = {}) {
        return (
            <Checkbox
                checked={value}
                onChange={onChange}
                disabled={disabled}
                style={style}
            >
                {label}
            </Checkbox>
        );
    }

    render() {
        const { form, message, isLoading, table } = this.state;

        return (
            <div>
                <Form>
                    {this.renderSetsOfDayTypes(
                        isLoading,
                        table.data
                    )}

                    <FormGroup>
                        <label className="bussched-form-label">
                            Apresentar Zebras Alternadas
                        </label>
                        <div className= "bussched-checkbox-container">
                            {this.renderCheckbox(
                                "Horas",
                                form.showHourZebraStripes,
                                () => this.onChangeCheckboxValue("showHourZebraStripes")
                            )}
                            {this.renderCheckbox(
                                "Minutos",
                                form.showMinutesZebraStripes,
                                () => this.onChangeCheckboxValue("showMinutesZebraStripes")
                            )}
                        </div>
                    </FormGroup>


                    {this.renderNumberInput(
                        "Número Linhas a Apresentar [1..36]",
                        "Número Linhas a Apresentar",
                        form.numberColumns,
                        "formNumberColumnsText",
                        1,
                        36,
                        this.handleFormFieldChange("numberColumns")
                    )}

                    {this.renderNumberInput(
                        "Primeira Hora a Apresentar [0..23]",
                        "Primeira Hora a Apresentar",
                        form.startingHour,
                        "formStartingHourText",
                        0,
                        23,
                        this.handleFormFieldChange("startingHour")
                    )}
                </Form>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.onFinishSelectData()}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={this.onExitMessage}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/DayVerticalTimesheetDataIdentifier.js